/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { makeAsyncAction } from 'ui-lottery/src/utils/async_utils';
import * as api from '../api';
import * as types from '../constants/actions';

export const fetchFacilities = makeAsyncAction(
    types.FETCH_FACILITIES,
    () => () => api.getFacilities(),
    'facilities'
);

export const fetchFacility = makeAsyncAction(
    types.FETCH_FACILITY,
    (facilityId) => () => api.getFacility(facilityId),
    'facility'
);

export const fetchFacilityByIdOrSlug = makeAsyncAction(
    types.FETCH_FACILITY_BY_ID_OR_SLUG,
    (facilityId) => () => api.getFacilityByIdOrSlug(facilityId),
    'facility'
);
